import { Box, Chip, Typography } from "@mui/material";
import { CustomDataGrid } from "../../../common/components/Table/CustomDataGrid";

const StaticCompletedTable = ({
    schedule,
    columns,
    initialState = { pinnedColumns: { left: ["batch_number", "batch_no", "material_name", "product_name"], right: ["analyst_id", "machine_id", "machine_start_time", "machine_end_time", 'status',], } },
    title,
    show_count = false,
    height = 300,
    hidden_fields = [],
    gridApiRef,
    aria_label
}) => {
    // console.log(columns);
    return (
        <Box className="my-4">

            <Box className="flex items-center gap-4 my-2">
                <Typography variant="h5" mb="0" gutterBottom align="left">
                    {title}
                </Typography>
                {
                    show_count &&
                    <Chip label={`Total Tests : ${schedule.length}`} />
                }
            </Box>
            <Box sx={{ height, width: "100%" }}>
                <CustomDataGrid
                    editMode={"row"}
                    aria-label={aria_label}
                    columns={Object.values(columns)?.length > 0 && Object.values(columns)}
                    rows={schedule}
                    hideFooter
                    columnVisibilityModel={{
                        id: false,
                        _id: false,
                        // stp_id: false,
                        ...hidden_fields?.reduce((acc, el) => ({
                            ...acc,
                            [el]: false
                        }), {})
                    }}
                    initialState={initialState}
                    //   getRowClassName={getRowClassName}
                    slots={{
                        noRowsOverlay: () => <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                        }}>
                            <p className='text-lg'>No {title} Found</p>
                        </div>
                    }}
                />
            </Box>

        </Box>
    );
}
export default StaticCompletedTable